import React, { FC, lazy } from 'react';

interface BreadcrumbItem {
    label: string;
    href: string;
}

type Props = {
    text?: any
    className?: string
    title?: string
    btn?: string
    breadcrumb?: BreadcrumbItem[];
    description?: string
    link?: string
    lg?: string
}

const Breadcrumb = lazy(() => import('../layout/Breadcrumb'));
const MainButton = lazy(() => import('./buttons/MainButton'));
const MainText = lazy(() => import('./text/MainText'));

const Hero: FC<Props> = ({ text, lg, link, title, btn, breadcrumb, description }) => {
    return (
        <div className={'row justify-content-center'}>
            <div className={'col-md-8 text-center'}>
                {breadcrumb && breadcrumb.length > 0 &&
                    <Breadcrumb breadcrumb={breadcrumb} />
                }

                {/* {title && <SecondaryTitle className={'title-h6 lazy-text'} text={title}/>}
                {text && <MainTitle className={`main-title lazy-text ${lg}`} text={text}/>} */}
                <h1 className={`main-title lazy-text ${lg}`}>
                    <span className={'title-h6 lazy-text'}>{title}</span> <br />
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                    {/* {text} */}
                </h1>
                {description && <MainText className={'main-text lazy-text'} text={description} />}
                {btn && <div className={'row justify-content-center mt-4'}>
                    <div className={'col-lg-5 col-md-10  col-10'}>
                        <MainButton href={`/${link}`} className={'btn btn-main  lg w-100'} text={btn} withLogo={true} />
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default Hero;